import { makeStyles } from '@material-ui/core/styles'
import { Card, CardContent, Typography, Divider } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(() => ({
  header: {
    textTransform: 'uppercase',
  },
}))

interface CardBarProps {
  title: string
  chart: React.ReactNode
}

function CardBar({ title, chart }: CardBarProps) {
  const classes = useStyles()
  return (
    <>
      <Card>
        <CardContent>
          <Typography className={classes.header} color="textPrimary">
            {title}
          </Typography>
          <Divider />
          {chart}
        </CardContent>
      </Card>
    </>
  )
}

export { CardBar }
